import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startDate", "endDate", "dayDates", "selectAll", "dayCheckbox"]
  static values = { locale: { type: String, default: "pl" } }

  connect() {
    this.updateDates()
    this.updateSelectAll()
  }

  updateDates() {
    const startDate = this.parseDate(this.startDateTarget.value)
    const endDate = this.parseDate(this.endDateTarget.value)
    if (!startDate || !endDate || endDate < startDate) return

    const dayMap = { monday: 1, tuesday: 2, wednesday: 3, thursday: 4, friday: 5, saturday: 6, sunday: 0 }
    const locale = this.localeValue === "pl" ? "pl-PL" : "en-US"

    this.dayDatesTargets.forEach(el => {
      const day = el.dataset.day
      const dayIndex = dayMap[day]
      const dates = []

      const current = new Date(startDate.getTime())
      while (current <= endDate) {
        if (current.getDay() === dayIndex) {
          dates.push(current.toLocaleDateString(locale, { day: "numeric", month: "short" }))
        }
        current.setDate(current.getDate() + 1)
      }

      el.textContent = dates.length > 0 ? dates.join(", ") : ""
    })
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.dayCheckboxTargets.forEach(cb => {
      if (cb.checked !== checked) {
        cb.checked = checked
        this.toggleDaySelects(cb)
      }
    })
  }

  toggleDay(event) {
    this.toggleDaySelects(event.target)
    this.updateSelectAll()
  }

  navigateWeek(event) {
    event.preventDefault()
    const delta = parseInt(event.currentTarget.dataset.delta)
    const startDate = this.parseDate(this.startDateTarget.value)
    if (!startDate) return

    const newStart = new Date(startDate.getTime())
    newStart.setDate(newStart.getDate() + (delta * 7))
    const newEnd = new Date(newStart.getTime())
    newEnd.setDate(newEnd.getDate() + 6)

    this.startDateTarget.value = this.formatDate(newStart)
    this.endDateTarget.value = this.formatDate(newEnd)
    this.updateDates()
  }

  // private

  parseDate(value) {
    if (!value) return null
    const [y, m, d] = value.split("-").map(Number)
    return new Date(y, m - 1, d)
  }

  toggleDaySelects(checkbox) {
    const row = checkbox.closest("[data-day]")
    row.querySelectorAll("select").forEach(input => {
      input.disabled = !checkbox.checked
    })
  }

  updateSelectAll() {
    if (!this.hasSelectAllTarget) return
    const allChecked = this.dayCheckboxTargets.length > 0 &&
      this.dayCheckboxTargets.every(cb => cb.checked)
    this.selectAllTarget.checked = allChecked
    this.selectAllTarget.indeterminate = !allChecked &&
      this.dayCheckboxTargets.some(cb => cb.checked)
  }

  formatDate(date) {
    const y = date.getFullYear()
    const m = String(date.getMonth() + 1).padStart(2, "0")
    const d = String(date.getDate()).padStart(2, "0")
    return `${y}-${m}-${d}`
  }
}
